var exports = {
  "s": "xaee3c4fa--79ccb2--icon-wrapper",
};

module.exports = exports;
